<!--
 * @Author: 单译 2694138418@qq.com
 * @Date: 2022-08-08 09:39:52
 * @LastEditors: 单译 2694138418@qq.com
 * @LastEditTime: 2022-12-13 14:45:58
 * @FilePath: \music\src\components\dialog\paySuccess.vue
 * @Description: 
 * 
 * Copyright (c) 2022 by 单译 2694138418@qq.com, All Rights Reserved. 
-->
<template>
    <div class="settlement_box">
        <el-dialog :modal-append-to-body="false" custom-class="delCarMusic" :close-on-click-modal="false" title="用户认证"
            :visible.sync="paySuccess" width="540px" :before-close="handleClose">
            <div class="paySuccess">
                <!-- <img src="../../assets/home/success.png" alt=""> -->
                <img src="../../assets/home/success.png" alt="">
                <h3>支付成功！</h3>
                <div>
                    <!-- <a href="javascript:void(0)">下载歌曲</a>
                    <a href="javascript:void(0)" @click="apply" v-if="orderDetail.invoice_status==0">申请发票</a>
                    <a href="javascript:void(0)" v-if="orderDetail.invoice_status==1">待开票</a>
                    <a href="javascript:void(0)" @click="gain" v-if="orderDetail.empower_status==0">获取授权书</a>
                    <a href="javascript:void(0)" v-else>待签发</a> -->
                    <a href="javascript:void(0)">下载歌曲</a>
                    <a href="javascript:void(0)">申请发票</a>
                    <a href="javascript:void(0)">获取授权书</a>
                </div>
                <p>说明：后续随时可在“已完成订单”中进行以上操作</p>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            paySuccess: false,
        }
    },
    methods: {
        handleClose() {
            this.paySuccess = false
        },
        // 获取订单详情
        getOrderDetail() {
            let val = {
                id: this.$route.query.id
            }
            this.flag = 0
            // 获取歌曲信息
            this.$home.orderInfo(val).then(res => {
                if (res.code == 200) {
                    this.orderDetail = res.data
                }
            }).catch(err => {
                //console.log(err);
            })
        },
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__title {
    font-weight: 600;
}


.paySuccess {
    // width: 1200px;
    // height: 258px;
    background: #FBFBFB;
    text-align: center;
    margin-bottom: 20px;
    opacity: 1;
    // padding: 30px 30px 38px 30px;

    img {
        width: 52px;
        height: 52px;
    }

    h3 {
        font-size: 20px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222222;
        line-height: 23px;
        margin: 25px 0 20px 0;
    }

    div {
        display: flex;
        // grid-column-gap: 30px;
        margin: auto;
        width: 260px;
        justify-content: space-evenly;

        a {
            color: #D92A20;
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #D92A20;
            line-height: 16px;
        }
    }

    p {
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 16px;
        margin-top: 20px;
    }
}
</style>